import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsScimScimEditSettingsCacheKeys: AllRouteEndpoints[] = ["/integrations/scim/scim_info"];
